module.exports = __webpack_public_path__ + "static/bg-firm-71f48ac55fe605e76d5fdd4ead57af7a.jpg";